import { render, staticRenderFns } from "./AreaNotesTableItem.vue?vue&type=template&id=2b6d1251&scoped=true"
import script from "./AreaNotesTableItem.vue?vue&type=script&lang=ts"
export * from "./AreaNotesTableItem.vue?vue&type=script&lang=ts"
import style0 from "./AreaNotesTableItem.vue?vue&type=style&index=0&id=2b6d1251&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6d1251",
  null
  
)

export default component.exports